module.exports = __webpack_public_path__ + "img/KM-360AN.6951c36e.png";